module.exports = __webpack_public_path__ + "img/J＆G Fried Chicken-01.18a29c9f.svg";